import type { SocialNetworksBlockProps } from "./types";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { SocialNetworksEmailRenderer } from "./email";
import { useMemo } from "react";

export function SocialNetworksEditorRenderer({
  ...props
}: SocialNetworksBlockProps) {
  const { shop } = props;

  const socialNetworks = useMemo(() => {
    return shop.externalLinks
      ? Object.entries(shop.externalLinks).filter(
          ([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url,
        )
      : [];
  }, [shop.externalLinks]);

  if (socialNetworks.length === 0) {
    return (
      <div className="w-full flex justify-center">
        <div className="text-muted-foreground text-sm px-4 py-2 border border-dashed rounded">
          Aucun réseau social configuré
        </div>
      </div>
    );
  }

  return (
    <EmailComponentWrapper shop={props.shop}>
      <SocialNetworksEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
